import { ReactElement } from 'react'
import { Card, Tabs, Typography } from 'antd'
import { SettingOutlined, ApiOutlined } from '@ant-design/icons'
import General from './General'
import ApiKeys from './ApiKeys'
import styles from './Settings.module.scss'

const { Title } = Typography

const Settings = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Card>
          <Title level={2}>Settings</Title>
          <Tabs
            defaultActiveKey="api-keys"
            items={[
              {
                key: 'general',
                label: (
                  <span>
                    <SettingOutlined style={{ marginRight: 6 }} />
                    General
                  </span>
                ),
                children: <General />,
              },
              {
                key: 'api-keys',
                label: (
                  <span>
                    <ApiOutlined style={{ marginRight: 6 }} />
                    API Keys
                  </span>
                ),
                children: <ApiKeys />,
              },
            ]}
          />
        </Card>
      </div>
    </div>
  )
}

export default Settings
